import React from 'react'
import ThemeDivider from './ThemeDivider'

const Divider = ({
  content: {
    text,
  },
  style,
  settings,
  currentLang,
  renderElement,
}) => {
  return (
    renderElement(
      ThemeDivider,
      {
        style,
        ...settings,
        children: text[currentLang],
      }
    )
  )
}

Divider.propTypes = {}
Divider.defaultProps = {}

export default Divider



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/divider/Divider.js